import React, { useState, useRef, useEffect } from "react";
import { ImCross } from "react-icons/im";
import axios from "axios";
import { toast } from "react-toastify";
import UpdateForm from "./UpdateForm";
import { MyContextSupply } from "../../../../Context";

const AdminUpdateItem = ({
  isUpdatingProducts,
  setIsUpdatingProducts,
  updatingData,
  setRunDelete,
}) => {
  const { token } = MyContextSupply();
  const [currentCldImgExist, setCurrentCldImgExist] = useState("");
  const [productInfo, setProductInfo] = useState({
    shortTitle: "",
    longTitle: "",
    description: "",
    mrp: "",
    cost: "",
  });
  const [category, setCategory] = useState("");
  const [showImage, setShowImage] = useState("");
  const [tagline, setTagline] = useState("");
  const [cloudinaryImageFile, setCloudinaryImageFile] = useState("");
  const imageRef = useRef(null);
  const [isUploadLoading, setIsUploadLoading] = useState(false);
  const [productId, setProductId] = useState("");

  const { shortTitle, longTitle, description, mrp, cost } = productInfo;

  const toggleRunDelete = () => {
    setRunDelete((prev) => {
      return prev + 1;
    });
  };

  const toastStyle = {
    position: "top-center",
    autoClose: 2000,
  };

  const OnSubmitUploadProduct = async (e) => {
    e.preventDefault();
    if (
      shortTitle !== "" &&
      longTitle !== "" &&
      description !== "" &&
      mrp !== "" &&
      cost !== "" &&
      category !== "" &&
      tagline !== ""
    ) {
      if (currentCldImgExist !== "" && !cloudinaryImageFile) {
        axios
          .put(
            `https://stechbackend-9r4c.onrender.com/admin/product/update/${productId}`,
            {
              title: { shortTitle, longTitle },
              description,
              price: { mrp, cost },
              category,
              tagline,
              url: currentCldImgExist,
            },
            { headers: { Authorization: token }, withCredentials: true }
          )
          .then((res) => {
            if (res.status === 201) {
              toast.success("Product data updated successfully!", {
                position: "top-center",
              });
              toggleRunDelete();
              e.target.reset();
              const Delay = setTimeout(() => {
                setIsUpdatingProducts(false);
              }, 2000);
              return () => {
                clearTimeout(Delay);
              };
            }
          })
          .catch((err) => {
            const message = err.response.data.message;
            if (err) {
              toast.warn(message, toastStyle);
            }
          });
      } else if (showImage !== "") {
        const formData = new FormData();
        const publicId = cloudinaryImageFile.name.split(".")[0];
        formData.append("file", cloudinaryImageFile);
        formData.append("public_id", publicId);
        formData.append("upload_preset", "stechnology");
        return await axios
          .post(
            "https://api.cloudinary.com/v1_1/stechnologyimages/image/upload/",
            formData
          )
          .then((res) => {
            if (res.status === 200) {
              if (res.data.secure_url) {
                axios
                  .put(
                    `https://stechbackend-9r4c.onrender.com/admin/product/update/${productId}`,
                    {
                      url: res.data.secure_url,
                      category,
                      description,
                      tagline,
                      title: { shortTitle, longTitle },
                      price: { mrp, cost },
                    },
                    { headers: { Authorization: token }, withCredentials: true }
                  )
                  .then((response) => {
                    if (response.status === 201) {
                      toggleRunDelete();
                      toast.success("Product data updated successfully!", {
                        position: "top-center",
                      });
                      setCategory("");
                      setShowImage("");
                      setCloudinaryImageFile("");
                      setTagline("");
                      imageRef.current.value = "";
                      e.target.reset();
                      const Delay = setTimeout(() => {
                        setIsUpdatingProducts(false);
                      }, 2000);
                      return () => {
                        clearTimeout(Delay);
                      };
                    }
                  })
                  .catch((err) => {
                    const message = err.response.data.message;
                    if (err) {
                      toast.warn(message, toastStyle);
                    }
                    setIsUploadLoading(false);
                  });
              }
            }
          })
          .catch((error) => {
            console.log(error);
            setIsUploadLoading(false);
          });
      }
    } else {
      toast.warn("please fill all the inputs!");
    }
  };

  //   below useEffect for setting the existing data in the inputs
  useEffect(() => {
    const {
      category,
      description,
      price,
      tagline,
      title,
      url,
      _id: id,
    } = updatingData && updatingData;
    const { cost, mrp } = price !== undefined && price;
    const { shortTitle, longTitle } = title !== undefined && title;

    // now setting the values to the state
    setProductId(id);
    setProductInfo({
      shortTitle: shortTitle,
      longTitle: longTitle,
      description: description,
      mrp: mrp,
      cost: cost,
    });
    setCategory(category);
    setTagline(tagline);
    setShowImage(url);
    setCurrentCldImgExist(url);
  }, [isUpdatingProducts]);
  //   console.log(isUploadLoading);
  return (
    <section className="desh-main-display desh-main-display-and-add">
      <span
        onClick={() => setIsUpdatingProducts(false)}
        className="close-update-form"
      >
        <ImCross />
      </span>
      <UpdateForm
        OnSubmitUploadProduct={OnSubmitUploadProduct}
        productInfo={productInfo}
        setProductInfo={setProductInfo}
        category={category}
        setCategory={setCategory}
        tagline={tagline}
        setTagline={setTagline}
        imageRef={imageRef}
        setCloudinaryImageFile={setCloudinaryImageFile}
        showImage={showImage}
        setShowImage={setShowImage}
        isUploadLoading={isUploadLoading}
        setCurrentCldImgExist={setCurrentCldImgExist}
      />
    </section>
  );
};

export default AdminUpdateItem;
